import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { addTeams, updateTeams } from '../../actions/userActions/teamAction'
import Loader from '../subComponents/Loader'
import { Redirect, useLocation, useHistory } from 'react-router-dom';
import HrComponent from '../reuse_components/HrComponent';
import BodyLargeMedium from '../designSystem/BodyLargeMedium';
import { IconButton } from '@mui/material';
import Textarea from '../designSystem/TextArea';
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';
import TextField from '../designSystem/TextField';
import designationLevelIcon from "../../assets/images/designationLevelIcon.svg";
import closeModal from "../../assets/images/closeModal.svg";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import teamIcon from "../../assets/images/Icon=Team.svg";
import { validateFields } from '../../utils/Validations';
import { Check, X } from 'lucide-react';
import BodyMediumMedium from '../designSystem/BodyMediumMedium';
import CancelButton from '../subComponents/buttons/CustomCancelButton';
import PrimaryButton from '../subComponents/buttons/PrimaryButton';
import { t } from '../../locales/translate';
function AddTeams({ onClose, editData, onSave }) {

  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const initialValues = { name: "", description: "", active: false };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editData) {
      setFormValues(editData);
    }
  }, [editData]);
  const handleSave = async (e) => {
  e.preventDefault();
  const errors = validateFields(formValues, "team");
  setFormErrors(errors);
  if (Object.keys(errors).length > 0) return;
  
  setLoading(true);
  try {
    if (editData) {
      await dispatch(updateTeams(formValues));
    } else {
      await dispatch(addTeams(formValues));
    }
    setLoading(false);
    await onSave(formValues);
  } catch (error) {
    console.error("Error saving team:", error);
    setLoading(false);
  }
};
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    if (name === "active" && formValues.active === true) {
      setFormValues({ ...formValues, [name]: false });
    }
    else if (name === "active" && formValues.active === false) {
      setFormValues({ ...formValues, [name]: true });
    }
  }
  const addTeam = useSelector(state => state.teams_reducer.addTeams);
  const updateTeam = useSelector(state => state.teams_reducer.updateTeams);
  const permissions = JSON.parse(localStorage.getItem("permissionsList"));

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <>
      <div className="dynamicmodal-overlay">
        <div className="dynamicmodal-container overlay-wrapper">
          <LoadingOverlay isVisible={loading} />
          <div className={loading ? 'blur' : ''}>
          <div className="dynamicmodal-header mb-3">
            <div className="dynamicmodal-header-left">
              <div className="icon">
                <img src={teamIcon} alt="teamIcon " />
              </div>
              <div className="text">
                <h2 className="modalheading">
                  {editData ? "Edit Team" :`${t("addTeam")}`}
                </h2>
                <p className="modaldescription">
                  {t("addTeamTip")}
                </p>
              </div>
            </div>
            <div className="dynamicmodal-header-right">
              <IconButton onClick={onClose}>
                <img src={closeModal} alt="" />
              </IconButton>
            </div>

          </div>


          <form onSubmit={handleSave}>
            <div className="dynamicmodal-body">

              <TextField
                name="name"
                label={`${t("name")} *`}
                type='text'
                value={formValues.name}
                onChange={handleChange}
                placeholder={t("name")}
                error={formErrors.name}
              />

              <Textarea
                name="description"
                label={`${t("description")} *`}
                placeholder={t("description")}
                value={formValues.description}
                onChange={handleChange}
                error={formErrors.description}
              />
              <div className=" mt-2 ml-0">
                <div
                  className="form-group"
                  style={{ display: "flex", alignItems: "flex-start" }}
                >
                  <input
                    name="active"
                    style={{ cursor: "pointer", height: "14px", width: "14px" }}
                    type="checkbox"
                    checked={formValues.active}
                    className="ml-1 mt-1"
                    onChange={handleChange}
                  />
                  <label
                    style={{ paddingLeft: "5px" }}
                    className="form-control-label"
                  >
                    <div style={{ padding: '2px' }}>
                      <BodyMediumMedium text={t("active")} color="#1E293B" />
                    </div>
                  </label>
                </div>
              </div>

            </div>
           <div className="dynamicmodal-footer">
                        <CancelButton
                         onClick={onClose}
                         text={t("cancel")}
                        width={document.body.dir === "rtl" ? "119px" : ""}
                         />
                         <PrimaryButton
                         text={t("save")}
                         icon={Check}
                         width={document.body.dir === "rtl" ? "123px" : ""}
                         />
                       </div>
          </form>
        </div>
      </div>
      </div>

    </>
  );
}

export default AddTeams
